import dayjs from 'dayjs';
import { GetDashboardByTokenQuery } from 'generated/graphql';
import { Dashboard } from 'v2/core/entities/dashboard';
import { SourceDetail } from 'v2/core/entities/feedback/sources';
import { SourceName } from 'v2/core/entities/fields';
import { Reporting, ReportingType } from 'v2/core/entities/report';
import { Timezone } from 'v2/core/entities/user';
import {
  mapFromEdgeScope,
  mapFromEdgeStatus,
} from 'v2/core/repository/edge-server/analysis/fromEdgeAnalysis';
import { ReportSchedule } from 'v2/core/repository/edge-server/analysis/types';
import { mapToDashboardListItem } from 'v2/core/repository/edge-server/dashboard/useListDashboards';
import { getNewAnalysisCompatibleWithOld } from '../utils/newAnalysisCompatibleWithOld';

type EdgeDashboard = Required<GetDashboardByTokenQuery>['getDashboardByToken'];

export const mapFromEdgeReporting = (
  reporting?: Reporting,
): ReportSchedule | undefined => {
  if (!reporting) {
    return undefined;
  }

  const feedbackSchedule = reporting.secondarySchedules?.find(
    (schedule) => schedule.reportType === ReportingType.DefaultReport,
  );

  return feedbackSchedule;
};

const mapFromEdgeDashboard = (
  edgeDashboard: EdgeDashboard,
  sourceDetailsMap: Map<SourceName, SourceDetail>,
  timezone: Timezone,
): Dashboard => ({
  id: edgeDashboard.id,
  title: edgeDashboard.title,
  viewToken: edgeDashboard.viewToken,
  editToken: edgeDashboard.editToken,
  metadata: edgeDashboard.metadata,
  scope: mapFromEdgeScope(edgeDashboard.scope),
  analyses:
    edgeDashboard.analyses?.map((edgeAnalysis) => {
      return {
        ...getNewAnalysisCompatibleWithOld(edgeAnalysis),
      };
    }) ?? [],
  createdBy: {
    ...edgeDashboard.createdBy,
    firstName: edgeDashboard.createdBy.firstName,
    lastName: edgeDashboard.createdBy.lastName,
  },
  createdAt: dayjs.unix(edgeDashboard.createdAt),
  updatedAt: dayjs.unix(edgeDashboard.updatedAt),
  reportSchedule: mapFromEdgeReporting(edgeDashboard.reporting),
  origin:
    edgeDashboard.originDashboard &&
    mapToDashboardListItem(edgeDashboard.originDashboard),
  isReportingDisabled: edgeDashboard.isReportingDisabled,
  status: mapFromEdgeStatus(edgeDashboard.status),
  version: edgeDashboard.version,
});

export default mapFromEdgeDashboard;
